AuthInterceptor.$inject = ['$q', '$cookies', '$injector','$rootScope'];

export default function AuthInterceptor($q, $cookies, $injector,$rootScope) {

  let service = {
    request,
    response,
    requestError,
    responseError
  };
  return service;

  function request(config) {
    //  console.log(config);
    config.headers = config.headers || {};
    try {
      sessionStorage.setItem('dummy', 'value');
      if (config.url.includes('api.taxjar.com')) {
        config.headers.Authorization = 'Token token=920436a58e41be430c1de5bae3c72c9b';
      } else if (sessionStorage.getItem('guestoauth') && sessionStorage.getItem('isGuestUserLoggedIn')) {
        if (config.url.startsWith('/api/v1/customer/cart?isCartPage')
        || config.url == '/api/v1/customer/isgivexavailable'
        || config.url == '/api/v1/customer'
        || config.url.startsWith('/api/v1/customer/order') 
        || config.url == '/api/v1/customer/payment/keys'
        || config.url == '/api/v1/customer/getgiftcardbalance'
        || config.url == '/api/v1/customer/orderusinggiftcards'
        || (config.url.startsWith('/api/v1/customer/payment/print') && (config.url.indexOf('/logs') !== -1))
        || (config.url.startsWith('/api/v1/customer/order') && config.url.endsWith('/summary'))
        || config.url == '/api/v1/customer/heartland/initialize/payment'
        || config.url == '/api/v1/customer/tsys/initialize/payment'
        || config.url == '/api/v1/customer/moneris/payment/process'
        || config.url == '/api/v1/customer/paypal/createorder'
        || config.url == '/api/v1/customer/paypal/captureorder'
        || config.url == '/api/v1/store/features') {
          config.headers.Authorization = `OAuth ${sessionStorage.getItem('guestoauth')}`;
        }
      } else if (sessionStorage.getItem('oauth')) {
        config.headers.Authorization = `OAuth ${sessionStorage.getItem('oauth')}`;

      }
      if (sessionStorage.getItem('storeId') && sessionStorage.getItem('storeId')!='') {
        // let guestStore = sessionStorage.getItem('guestStoreName');
        // if(guestStore && guestStore != '') {
        //   config.headers.storeCode = '';
        // }
        // else {
        config.headers.storeCode = sessionStorage.getItem('storeId');
        // }
      }
      else {
        config.headers.storeCode = '';
      }

    }
    catch (e) {
      if (config.url.includes('api.taxjar.com')) {
        config.headers.Authorization = 'Token token=920436a58e41be430c1de5bae3c72c9b';
      }
      else if ($cookies.get('oauth')) {
        config.headers.Authorization = `OAuth ${$cookies.get('oauth')}`;
      }
      config.headers.storeCode = '';
      if ($cookies.get('storeId') && $cookies.get('storeId')!='') {
        config.headers.storeCode = $cookies.get('storeId');
      } else {
        config.headers.storeCode = '';
      }
    }
    return config;
  }

  function requestError(rejection) {
    return $q.reject(rejection);
  }

  function response(response) {
    return response;
  }

  function responseError(rejection) {
    if (rejection.status === 403) {
      let $state = $injector.get('$state');
      let $location = $injector.get('$location');
      let toaster = $injector.get('toaster');
      // console.log(toaster);
      if ($location.path().indexOf('auth') === -1 &&
        $state.current.name !== 'login' &&
        $state.current.name !== 'signup') {
        sessionStorage.removeItem('oauth');
        $rootScope.$emit('forbidden');

        /* $state.go('login');
        toaster.pop('success', 'Your session has expired. Please login again.');*/
      }
    }
    return $q.reject(rejection);
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/interceptor.js